module.exports = __webpack_public_path__ + "assets/img/single_sentence.3be2b4f8.png";